#import "./inbox-related-lead-stage-edge-fragment.graphql"

fragment InboxRelatedLeadFragment on Lead {
    id
    name
    number
    avatarUrl
    htmlUrl
    status
    priority
    value {
        formatted
    }
    assignee {
        id
        name
        ... on User {
            avatarUrl
            initials
        }
    }
    contacts {
        primaryEdge {
            node {
                id
                name
                jobTitle
                avatarUrl
                primaryPhoneNumber
                primaryEmailAddress
                accounts {
                    primary {
                        id
                        name
                    }
                }
            }
        }
    }
    accounts {
        primaryEdge {
            node {
                id
                name
            }
        }
    }
    stageset {
        id
        name
    }
    stages {
        current {
            id
            name
        }
        edges {
            ...InboxRelatedLeadStageEdgeFragment
        }
    }
    tags {
        id
        name
        color
    }
}
